<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Counters",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Counters",
            items: [
               {
                  text: "Counters",
                  active: true,
               },                   
            ],

            
            counters: [],
            pharmacy: [],
            type : 2,
           
            status: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            button_title: "Save",
            pagination: {},
            isEdit: false,
            modal_title: "Add Counter",

            form: {
                id: null,
                counter_name: '',
                username: '',
                password:'',
                token_management_type: 2,
                priority_type: '',
                prefix: '',
                scroll_up: 2,
            },
            change_password: {
                    password: '',
                    password_confirmation: '',
            },
            
            active_page_url: null,
            
            loading: false,
         };
      },
      mounted() {

      },

      created() {
         this.fetchCounters();
      },

      methods: {


         fetchCounters(page_url = null){

            this.getToken();

            let url = "api/admin/counters?limit=" + this.listing_length +
                        "&status=" + this.status +
                        "&keyword=" + this.keyword +
                        "&type=" + this.type +
                        "&pharmacy_id=" + this.$route.params.id;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.counters = responseData.counters.data;
               this.pharmacy = responseData.details;
               this.from = responseData.counters.from;
               this.to = responseData.counters.to;
               this.total = responseData.counters.total;
               this.pagination = responseData.counters.links;



            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));





         },
         
          getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 



         formatTokenManagementType(type) {
            const types = { 2: 'Current token tracking', 3: 'OP outsource' };
            return types[Number(type)] || '-';
         },

         formatDate(dateString) {
			const date = new Date(dateString);

			const day = date.getDate();
			const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
			const year = date.getFullYear();

			const hours24 = date.getHours();
			const minutes = date.getMinutes();
			const hours12 = hours24 % 12 || 12;
			const ampm = hours24 >= 12 ? 'PM' : 'AM';

			return `${day} ${month} ${year}, ${hours12}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
		},
         
       
       
        showModal(modal) {
            this.$refs[modal].show();
        },
        hideModal(modal) {
            this.$refs[modal].hide();
        },
        
        editCounter(counter) {
            this.modal_title = 'Edit Counter';
            this.button_title = 'Update';
            this.isEdit = true;
            this.form.id = counter.id || '';
            this.form.counter_name = counter.counter_name || '';
            this.form.username = counter.username || '';
            this.form.token_management_type = counter.token_management_type || 2;
            this.form.priority_type = counter.priority_type || '';
            this.form.prefix = counter.prefix || '';
            this.form.scroll_up = counter.scroll_up || 2;
            this.form.password = ''; 

            // Open modal
            this.$refs['counter-modal'].show();
        },

        addCounterModal() {
            this.modal_title = 'Add Counter';
            this.button_title = 'Save';
            this.isEdit = false;
            this.clearForm();
            this.$refs['counter-modal'].show();
        },

        addCounter(){

            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            const url = this.isEdit
                ? 'api/admin/updateCounter'  
                : 'api/admin/addCounter';
                
            const payload = {
                counter_name: this.form.counter_name,
                username: this.form.username,
                type: this.type,
                token_management_type: this.form.token_management_type,
                priority_type: this.form.priority_type,
                scroll_up: this.form.scroll_up,
                pharmacy_id: this.$route.params.id,
                id  : this.form.id,
            };

            if (Number(this.form.priority_type) === 2) {
                payload.prefix = this.form.prefix;
            }

            if (!this.isEdit) {
                payload.password = this.form.password;
            }
            
            this.loading = true;
            
            this.$axios
               .post(url, payload, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.$refs['counter-modal'].hide();
                     this.fetchCounters(); 
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal('counter-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

   

         },

        counterDelete(counter) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this counter account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "api/admin/deleteCounter";
                     let formData = new FormData();
                     formData.append("counter_id", counter.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchCounters();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

         changePassword(counter) {      
                this.change_password.id = counter.id;
                this.edit = true;
                this.showModal("password-modal");
         },

         updatePassword() {
                this.getToken();           
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "api/admin/CounterChangePassword";
                this.active_page_url = null;
                let formData = new FormData();
                formData.append("counter_id", this.change_password.id); 
                formData.append("password", this.change_password.password); 
                formData.append("password_confirmation", this.change_password.password_confirmation); 
                
            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('password-modal');
                    this.fetchCounters(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
         }, 

         changeCounterStatus(counter_id, status){

            this.getToken();
            let url = "api/admin/updateCounterStatus?counter_id=" + counter_id + "&status=" + status;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchCounters();
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchTvs();
        },

           updateTitle() {
               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

               let formData = new FormData();
               formData.append("type", 2); 
               formData.append("pharmacy_id", this.$route.params.id); 
               formData.append("counter_title", this.pharmacy.counter_title); 
      
               let url = "api/admin/updateCounterTitle";
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('title-modal');
                  this.fetchCounters(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        // console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

        clearForm() {
            this.form = {
            counter_name: '',
            username: '',
            token_management_type: 2,
            priority_type: '',
            prefix: '',
            scroll_up: 2,
            password: ''
            };
            this.errors = {};
            this.isEdit = false;

            this.change_password.password = "";
            this.change_password.password_confirmation = "";
        },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                   <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">{{ pharmacy.name }}</h5>
                              <p>
                                 {{ pharmacy.address }}<br>
                                 {{ pharmacy.mobile }}
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 

                  <div class="row mb-3">
                     <div class="col-12">
                        <h5>Normal Counter Display Name : {{ pharmacy.counter_title }} </h5>
                        <b-button v-b-modal.counter-modal variant="primary" class="float-end" @click="addCounterModal()">Add Counter</b-button>
                        <b-button v-b-modal.title-modal variant="primary" class="float-end me-2">Update Normal Counter Display Name</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change = "fetchCounters()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchCounters()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change = "fetchCounters()">
                              <option value="">All</option>
                              <option value="1">Published</option>
                              <option value="2">Unpublished</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="15%">Name</th>   
                              <th width="15%">User Name</th>
                              <th width="15%">Token Management Type</th>
                              <th width="15%">Priority Type</th>
                              <th width="10%">Prefix</th>
                              <th width="10%">Scroll Up</th>
                              <th width="10%">Status</th>
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(counters.length)">
                           <tr v-for="counter in counters" :key="counter.id">
                              <td>{{ counter.counter_name }}</td>
                              <td>{{ counter.username }}</td>
                              <td>{{ formatTokenManagementType(counter.token_management_type) }}</td>
                              <td>{{ counter.priority_type == 1 ? 'Yes' : counter.priority_type == 2 ? 'Yes' : 'No' }}</td>
                              <td>
                                 <span v-if="counter.priority_type == 2">{{ counter.prefix || '-' }}</span>
                                 <span v-else>-</span>
                              </td>
                              <td>{{ Number(counter.scroll_up) === 1 ? 'Yes' : 'No' }}</td>
                              <td>
                                 <span v-if="counter.status==1" class="badge bg-success">Active</span>
                                 <span v-else-if="counter.status==2" class="badge bg-danger">Blocked</span>
                                 <span v-else class="badge bg-warning">Inactive</span>
                              </td>
                              <td>{{ formatDate(counter.created_at) }}</td>
                              <td>
                                 <b-button variant="primary" v-b-modal.counter-modal class="btn btn-sm me-2 mb-2" @click="editCounter(counter)">Edit</b-button> 
                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                 v-if="counter.status == 1" @click="changeCounterStatus(counter.id, 2)" >Unpublish</b-button>
                                 <b-button variant="success" class="btn-sm me-2 mb-2"
                                 v-if="counter.status == 2" @click="changeCounterStatus(counter.id, 1)" >Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                  @click="counterDelete(counter)" >Delete</b-button>
                                 <b-button variant="danger" class="btn-sm mb-2 me-2" @click="changePassword(counter)"><i class='bx bxs-key'></i></b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="9" class="text-center">No counters found</td>
                           </tr>
                        </tbody>

                  </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(counters.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchCounters(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&status=' + status + '&pharmacy_id=' + this.$route.params.id + '&type=2')">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                 
                <b-modal ref="counter-modal" id="counter-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="addCounter">
                        <div class="row">

                         <!-- Token Management Type -->
                        <div class="form-group col-md-12 mb-3">
                            <label class="control-label">Token Management Type <span class="text-danger">*</span></label>
                            <b-form-radio-group
                               v-model="form.token_management_type"
                               name="counterTokenType"
                               :class="{ 'is-invalid': errors.token_management_type }"
                               inline
                            >
                               <div class="form-check-inline">
                                  <b-form-radio :value="2">Current token tracking</b-form-radio>
                               </div>
                               <div class="form-check-inline">
                                  <b-form-radio :value="3">OP outsource</b-form-radio>
                               </div>
                            </b-form-radio-group>
                            <div class="invalid-feedback d-block" v-if="errors.token_management_type">
                               {{ errors.token_management_type[0] }}
                            </div>
                        </div>

                         <!-- Priority Type -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Priority Type <span class="text-danger">*</span></label>
                            <select
                               class="form-control"
                               v-model="form.priority_type"
                               :class="{ 'is-invalid': errors.priority_type }"
                            >
                            <option value="">Select</option>
                            <option value="2">Priority</option>
                            <option value="3">Normal</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.priority_type">
                            {{ errors.priority_type[0] }}
                            </div>
                        </div>

                        <!-- Prefix -->
                        <div class="form-group col-md-6 mb-3" v-if="Number(form.priority_type) === 2">
                            <label class="control-label">Prefix</label>
                            <input type="text" class="form-control" v-model="form.prefix" :class="{ 'is-invalid': errors.prefix }" />
                            <div class="invalid-feedback" v-if="errors.prefix">
                            {{ errors.prefix[0] }}
                            </div>
                        </div>

                        <!-- Counter Name -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Counter Name <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.counter_name" :class="{ 'is-invalid': errors.counter_name }" />
                            <div class="invalid-feedback" v-if="errors.counter_name">
                            {{ errors.counter_name[0] }}
                            </div>
                        </div>

                        <!-- Username -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Username <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.username" :class="{ 'is-invalid': errors.username }" />
                            <div class="invalid-feedback" v-if="errors.username">
                            {{ errors.username[0] }}
                            </div>
                        </div>

                       
                        <!-- Password -->
                        <div class="form-group col-md-6 mb-3" v-if="!isEdit">
                            <label class="control-label">Password <span class="text-danger">*</span></label>
                            <input type="password" class="form-control" v-model="form.password" :class="{ 'is-invalid': errors.password }" />
                            <div class="invalid-feedback" v-if="errors.password">
                            {{ errors.password[0] }}
                            </div>
                        </div>

                        <!-- Scroll Up -->
                        <div class="form-group col-md-12 mb-3 d-flex align-items-center">
                            <b-form-checkbox
                               v-model="form.scroll_up"
                               name="scroll_up"
                               value="1"
                               unchecked-value="2"
                               :class="{ 'is-invalid': errors.scroll_up }"
                            >
                               <span class="ms-2">Scroll Up</span>
                            </b-form-checkbox>
                            <div class="invalid-feedback d-block" v-if="errors.scroll_up">
                               {{ errors.scroll_up[0] }}
                            </div>
                        </div>
                        </div>

                        <!-- Buttons -->
                        <b-col md="12">
                        <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            {{ loading ? 'Saving...' : button_title }}
                        </b-button>
                        <b-button variant="light" @click="hideModal('counter-modal')" :disabled="loading">Close</b-button>
                        </b-col>
                    </b-form>
                </b-modal>

                    <!---- modal starts ---->
                  <b-modal ref="title-modal" id="title-modal" title="Update Normal Counter Display Name" hide-footer @hidden="clearForm()">
                     <b-form  @submit.prevent="updateTitle()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Title<span class="text-danger">*</span></label>
                           <b-form-input v-model="pharmacy.counter_title"></b-form-input>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                              <b-button class="" variant="light" @click="hideModal('title-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               <!----- update password modal starts ---->
                    <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
                        <b-form @submit.prevent="updatePassword()">
                            <b-row>  
                            <b-col lg="12" class="form-group">
                                <label class="control-label">New Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                                <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>  

                            <b-col lg="12" class="form-group">
                                <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                                <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>    
                            
                            <b-col lg="12">
                                <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                                <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
                            </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                  <!----- update password modal ends ---->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
